import { styled } from '@material-ui/core';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const Border = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.auth.divider}`,
  width: '100%',
}));

export const Content = styled('span')({
  paddingRight: '10px',
  paddingLeft: '10px',
  fontWeight: 600,
  fontSize: '14px',
});
